import PropTypes from "prop-types";
import styles from "./CardSettings.module.css";
import CheckItem from "Shared/CheckItem";
import Button from "Shared/Button";
import TrashButton from "components/TrashButton";
import Toggler from "components/Toggler";
import { useTranslation } from "react-i18next";

export function CardSettings({
  onSetDefault,
  onDelete,
  onEdit,
  onTogglePrimary,
  isDefault,
  isPrimary,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.checkItem}>
        <CheckItem
          itemTitle={t("Set as my default payment card")}
          isChecked={isDefault}
          onClick={onSetDefault}
        />
      </div>
      <div className={styles.actionRow}>
        <div className={styles.toggler}>
          <span className={styles.togglerLabel}>Primary: </span>
          <Toggler
            toggled={isPrimary}
            color="#39B54A"
            onChange={onTogglePrimary}
          />
        </div>
        <div className={styles.button}>
          <Button text={t("Edit")} className="editBtn" onClick={onEdit} />
        </div>
        <div className={styles.trash}>
          <TrashButton onClick={onDelete} isDisabled={isPrimary} />
        </div>
      </div>
    </div>
  );
}

CardSettings.propTypes = {
  onSetDefault: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  onTogglePrimary: PropTypes.func,
  isDefault: PropTypes.bool,
  isPrimary: PropTypes.bool,
};

export default CardSettings;
